export default {
  limit: 10,
  portfolio_token: "",
  search: null,
  sort_by: "",
  sort: "",
  status: 4,
};
